import { IdGenerator } from '../Utils/IdGenerator';
import { LameFlooringLayout } from '../Components/Laizes/Laize';
import { CoordPoint, Wall } from '../Utils/Types';
import { IContournements } from './Contournements';
import { IMapItem, YesOrNo } from './IMapItem';
import { IOpening } from './IOpening';
import { IRoomItem } from './IRoomItem';

export const LocalisationName = 'localisation_piece';
export enum RoomLocalisation {
    Inside = 'Intérieur',
    Outside = 'Extérieur',
}

export const TypeDeLocalName = 'Type de local';
export enum UnitType {
    Maison = 'Maison',
    Appartement = 'Appartement',
    LocalPro = 'Local pro',
    CoPro = 'Co-propriété',
}

export enum RoomShape {
    Rectangle = 'rectangle',
    Plus = 'plus',
    Diamond = 'diamond',
    Flyingwing = 'flyingwing',
    U = 'u',

    Custom = 'custom',

    //todo remove. Kept for retrocompat
    Diamond_topleft = 'diamond_topleft',
    Diamond_topright = 'diamond_topright',
    Diamond_bottomleft = 'diamond_bottomleft',
    Diamond_bottomright = 'diamond_bottomright',
    Flyingwing_topleft = 'flyingwing_topleft',
    Flyingwing_topright = 'flyingwing_topright',
    Flyingwing_bottomleft = 'flyingwing_bottomleft',
    Flyingwing_bottomright = 'flyingwing_bottomright',
    U_top = 'u_top',
    U_right = 'u_right',
    U_bottom = 'u_bottom',
    U_left = 'u_left',
}

export type RoomAngle = 0 | 90 | 180 | 270;

export const RoomAngleList: Array<RoomAngle> = [0, 90, 180, 270];

export const CanRotateRoomShapeOnCreation = {
    [RoomShape.Rectangle]: false,
    [RoomShape.Diamond]: true,
    [RoomShape.Flyingwing]: true,
    [RoomShape.U]: true,
    [RoomShape.Plus]: false,
};

export enum RoomType {
    Sol = 'Sol',
    Wall = 'Wall',
    Stairs = 'Stairs',
}

//! obsolete, kept for v2 export retrocompat
export type ObsoleteRoomDimensions = {
    //* Rectangle shape
    width?: number;
    height?: number;

    //* Diamond shape
    table?: number;
    right_crown?: number;
    left_crown?: number;

    //* FlyingWing shape
    left_wingtip?: number;
    left_trailing_edge?: number;
    right_wingtip?: number;
    right_trailing_edge?: number;

    //* U shape
    exterior_base?: number;
    left_exterior_edge?: number;
    left_tip?: number;
    left_interior_edge?: number;
    right_tip?: number;
    right_exterior_edge?: number;
};

//should be reanmed to somthing like IMapElement
// RoomType to MapElementType
//can be room, wall, stair

export interface IRoom extends IMapItem {
    type?: RoomType;
    //* ROOM INFOS : injected in context
    shape?: RoomShape;
    roomType?: string; // rename
    localisation?: RoomLocalisation;
    roomFloor?: string;
    roomFloorDescription?: string;
    roomWall?: string;
    roomExistingFlooring?: YesOrNo | string; //presenceRevetementAuSol
    roomExistingFloorType?: string;
    roomHeating?: YesOrNo | string;
    roomHeatingType?: string;

    flooringWallStart?: Wall; //* Mur d'alignement de départ pour la pose du revêtement (LaizeComputer V3)
    flooringWallStartValidated?: boolean;

    lameFlooringLayout?: LameFlooringLayout; //* Direction de pose du revêtement (LaizeComputer V3)

    contournements?: IContournements;

    //* injected by RoomPropEnhancer -> enhance
    raccord_length?: number;
    room_length?: number;
    surface_area?: number;
    surface_area_without_room_item?: number;
    surface_manipulee_prorata?: number;
    perimeter?: number;
    perimeter_plinthes?: number;
    should_lay_plinthes_inside_room_element?: boolean;
    wall_max_height?: number;

    stairsSteps?: Array<StairsSteps>;
    hasContremarches?: boolean;
    incompatibleWithPassage?: boolean;
    stairsBaseDeCalculs?: StairsBaseDeCalculs;

    //obsolete
    obsoleteDimensions?: ObsoleteRoomDimensions;
    center?: CoordPoint; //todo try to rm

    openings: Array<IOpening>;
    roomItems: Array<IRoomItem>;

    //* set on creation and update when walls changes
    sides?: Map<string, Array<CoordPoint>>;
    sidesObject?: Record<string, Array<CoordPoint>>; //!used for debug sides which is not display in ReactJson

    __comment_enum__?: string;

    //*COORDS
    coords?: Array<CoordPoint>;
    walls: Array<Wall>;
    areaWithoutRoomItems?: any;
    area?: number;
    inside?: any;
    customPoints?: Array<CoordPoint>;

    //todo: delete rotationAngle ?
    rotationAngle?: number;
    angle?: RoomAngle;
}

export interface StairsBaseDeCalculs {
    stairs_total_marches_droites?: number;
    stairs_total_marches_tournantes?: number;
    stairs_total_marches_arrondies?: number;
    stairs_total_paliers?: number;
    stairs_tread_count?: number;
    stairs_riser_count?: number;
    stairs_surface?: number;
    stairs_treads_surface?: number;
    stairs_risers_surface?: number;
    stairs_length?: number;
    stairs_longueur_totale_laize_metre?: number;
}

export enum StairsStepType {
    MarcheDroite = 'MarcheDroite',
    MarcheTournante = 'MarcheTournante',
    MarcheArrondie = 'MarcheArrondie',
    Palier = 'Palier',
}
export interface StairsSteps {
    id: string;
    name: string;
    type: StairsStepType;
    quantity: number;
    marches: number;//Emmarchement
    giron: number;//Profondeur de marche
    contremarches?: number;
}

export const createBaseRoom = (room: Partial<IRoom>): IRoom => ({
    ...room,
    roomId: IdGenerator.generate(),
    walls: [],
    openings: [],
    roomItems: [],
    coords: [],
    stairsSteps: [],
})